// Modules
import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

// Application
import { ROUTES_PATH } from 'constants/index'
import { useAccountMDMHook } from 'hooks'
import { formattedUrl } from 'utils'
import { useSignUpStepper } from 'redesign/hooks/useSignUpStepper'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'

// Components
import { TemplateContainer } from 'components'
import { NewPasswordSimplified } from 'components/Presenters/NewPasswordSimplified'
import { NewPassword, NewPasswordInitial } from 'components/Presenters/NewPassword'
import { SignUpHeader as Header } from 'redesign/components/organisms'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'

export const MDMCreatePassword: React.VFC = () => {
    const history = useHistory()
    const location = useLocation()
    const { isFeatureEnabled } = useRemoteConfig()
    const { hasMounted, biologicalSex, cpf, setPassword } = useAccountMDMHook()
    const { setStepValue, size, setStep } = useSignUpStepper()
    const shouldRedirect = !cpf || !biologicalSex
    const isPasswordSimplifiedActivated = isFeatureEnabled('AUTH_PASSWORD_SIMPLIFICATION')

    useSignUpAnaytics({
        hasMDM: true,
        defaultDispatchEvent: 'passwordOnOpen',
        shouldCall: hasMounted && !shouldRedirect,
    })

    useEffect(() => {
        if (size === 3) {
            setStepValue(0)
            return
        }
        setStep(1, 4)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!hasMounted) {
        return null
    }

    if (shouldRedirect) {
        history.replace(ROUTES_PATH.SIGN_IN)
        return null
    }

    const handleSubmit = async ({ password }: NewPasswordInitial) => {
        await setPassword(password)
        history.push(formattedUrl(location, 'teste', ROUTES_PATH.SIGN_UP_MDM_SELECT_CONTACT))
    }

    return (
        <TemplateContainer>
            <Header showStepper subtitle="Inclua os requisitos listados abaixo para criar uma senha segura:" title="Crie uma senha" />

            {isPasswordSimplifiedActivated ? (
                <NewPasswordSimplified handleSubmit={handleSubmit} hasMDM initialValues={{ password: '', confirmPassword: '' }} />
            ) : (
                <NewPassword handleSubmit={handleSubmit} hasMDM initialValues={{ password: '', confirmPassword: '' }} />
            )}
        </TemplateContainer>
    )
}
